// extracted by mini-css-extract-plugin
export var inlineLink = "_9z-0";
export var inlineLinkButton = "_9z-1";